import component from './component.vue';
import FItemArray from '../FItem/Array';

export default class FMark extends FItemArray {
  __component = component;

  set(value = []) {
    super.set(value);
  }
}
